import { useTranslations } from 'next-intl';
import { StyledDiv, StyledHeading, StyledSection } from './HardCodedHorizontalBannerComponent.styles';
import Br from '@atoms/Br/Br';

const HardCodedHorizontalBannerComponent = () => {
  const t = useTranslations('startPage');

  return (
    <StyledSection $fixed={false} $clickable={false}>
      <StyledDiv>
        <StyledHeading color="white" $fixed={false} variant="h2">
          {t('businessIdea.firstLine')} <Br />
          {t('businessIdea.secondLine')}&nbsp;{t('businessIdea.secondLineEnd')}
        </StyledHeading>
      </StyledDiv>
    </StyledSection>
  );
};

export default HardCodedHorizontalBannerComponent;
